import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import DistrictForm from '../components/DistrictForm';
import { useDistrictDetails } from '../hooks/useDistrictDetails';
import { useUpdateDistrict } from '../hooks/useDistrictMutations';
import type { DistrictFormData } from '@/shared/types';

export default function DistrictEditPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading: loadingDetails } = useDistrictDetails(id);
  const mutation = useUpdateDistrict();

  const handleSubmit = (formData: DistrictFormData) => {
    mutation.mutate({ id: id!, data: formData }, { onSuccess: () => navigate('/districts') });
  };

  if (loadingDetails) return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', padding: 48 }} />;

  return (
    <div>
      <PageHeader back title={t('districts.edit')} subtitle={data?.nameEn} />
      <Card style={{ marginTop: 16 }}>
        <DistrictForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
